import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import CostCustomSoftware2 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware2/CostCustomSoftware2';
import CostCustomSoftware3 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware3/CostCustomSoftware3';
import CostCustomSoftware4 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware4/CostCustomSoftware4';
import CostCustomSoftware5 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware5/CostCustomSoftware5';
import CostCustomSoftware6 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware6/CostCustomSoftware6';
import CostCustomSoftware7 from '../../../components/Satellites/customSoftware/CostCustomSoftware/CostCustomSoftware7/CostCustomSoftware7';

class CostCustomSoftware extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="cost_custom_software" />
        <ServiceBanner {...this.props} page="costCustomSoftware" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <CostCustomSoftware2 {...this.props} />
        <CostCustomSoftware3 {...this.props} />
        <CostCustomSoftware4 {...this.props} />
        <CostCustomSoftware5 {...this.props} />
        <CostCustomSoftware6 {...this.props} />
        <CostCustomSoftware7 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(CostCustomSoftware);
